export const AreaClearedOptions = [
  { value: '1', label: 'ใช่ เป็นพื้นที่โล่ง' },
  { value: '0', label: 'ไม่ใช่ มีสิ่งปลูกสร้าง/งานรื้อถอน' },
];

export const findAreaOptionLabel = (value: string) => {
  const newValue = AreaClearedOptions.find((e) => e.value === value);
  return newValue?.label;
};
